import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Fade from '@mui/material/Fade';
import Constant from "../../Constant";
import coins from "../../Assets/images/coins.png"

function ValuationRequestModal({ open, handleClose, mockData, onSubmit }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          p: 4,
          outline: 'none',
        }}>
          <div className="flex items-center mb-6">
            <ArrowBackIcon sx={{ fontSize: 18, color: "#1E222B" }} />
            <span>Back</span>
            <div className="ml-auto">
              <div onClick={handleClose} className="w-8 h-8 rounded-full bg-[#1E222B] text-white flex items-center justify-center cursor-pointer">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L13 13M1 13L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          </div>

          <div className="text-center mb-6">
            {/* Stack of Coins Icon Placeholder */}
            <div className="w-24 h-24 mx-auto bg-orange-100 rounded-full flex items-center justify-center mb-4">
              <img src={coins} alt='' />
            </div>
            <h2 className="text-[#000000] text-[20px] font-[700] mb-2">Requesting updated valuation</h2>
            <p className="text-[#A5A7AE] text-[13px] font-[400]">
              Before your position can be listed on the Secondary Market, we need an updated valuation of this property. This usually takes 1-3 business days.
            </p>
          </div>

          <div className="bg-[#F8FAFC] rounded-xl p-4 mb-6">
            <div className="flex justify-between py-2">
              <p className="text-[#808285] text-[12px]">Original investments cost</p>
              <p className="text-back-color2 text-[12px] font-bold">₦{Constant.FormatNumber(mockData?.originalInvestmentCost ?? 0)}</p>
            </div>
            <div className="flex justify-between py-2">
              <p className="text-[#808285] text-[12px]">Date of valuation request</p>
              <p className="text-back-color2 text-[12px] font-bold">{mockData?.dateOfValuationRequest || "N/A"}</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={onSubmit}
              className="w-full py-3 bg-[#00BC67] text-white rounded-lg font-[600] text-[15px]"
            >
              Submit valuation request
            </button>
            <button
              onClick={handleClose}
              className="w-full py-3 bg-white text-[#00BC67] rounded-lg font-[600] text-[15px]"
            >
              Cancel request
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ValuationRequestModal;
